import { useTranslation } from 'react-i18next';
import { Fund } from '@benzinga/etf-manager';
import { KPIBox } from './KPIBox';
import { DateTime } from 'luxon';

export const ETFHoldingsSummaryBoxes: React.FC<{ etfFund: Fund }> = ({ etfFund }) => {
  const { t } = useTranslation('quote');

  if (!etfFund) {
    return null;
  }

  return (
    <>
      {etfFund?.top_holder_snapshotdate && etfFund?.top_holder_snapshotdate != '' && (
        <p className="my-2 section-description">
          {t('Quote.Holdings.snapshot-date', {
            date: DateTime.fromISO(etfFund.top_holder_snapshotdate).toFormat('LLL dd, yyyy'),
          })}
        </p>
      )}

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <KPIBox
          label={t('Quote.Holdings.number-of-stock-holding-net')}
          value={String(etfFund.number_of_stock_holdingnet || '-')}
        />
        <KPIBox
          label={t('Quote.Holdings.number-of-bond-holding-net')}
          value={String(etfFund.number_of_bond_holdingnet || '-')}
        />
        <KPIBox
          label={t('Quote.Holdings.total-number-of-holdings')}
          value={String(etfFund.total_number_holding || '-')}
        />
        <KPIBox label={t('Quote.Holdings.number-of-etfs')} value={String(etfFund?.fund_etf_count || '-')} />
      </div>
    </>
  );
};

export default ETFHoldingsSummaryBoxes;
